import { GAMEPLAY_CONFIG } from '../../app/config';

const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value));
const lerp = (start: number, end: number, progress: number): number =>
  start + (end - start) * progress;

export type DifficultySnapshot = {
  difficulty: number;
  spawnIntervalMs: number;
  worldSpeed: number;
  maxActiveAsteroids: number;
  reactionTimeSeconds: number;
};

export const calculateDifficulty = (elapsedMs: number, score: number): DifficultySnapshot => {
  const elapsedSeconds = Math.max(0, elapsedMs) / 1000;
  const scoreFactor = Math.min(Math.max(0, score) / 100, 1);
  const timeFactor = 1 - Math.exp(-elapsedSeconds / 75);
  const difficulty = clamp(0.65 * timeFactor + 0.35 * scoreFactor, 0, 1);
  return {
    difficulty,
    spawnIntervalMs: lerp(
      GAMEPLAY_CONFIG.asteroid.spawnIntervalStartMs,
      GAMEPLAY_CONFIG.asteroid.spawnIntervalEndMs,
      difficulty,
    ),
    worldSpeed: lerp(70, 145, difficulty),
    maxActiveAsteroids: Math.round(
      lerp(
        GAMEPLAY_CONFIG.asteroid.maxActiveMin,
        GAMEPLAY_CONFIG.asteroid.maxActiveMax,
        difficulty,
      ),
    ),
    reactionTimeSeconds: lerp(
      GAMEPLAY_CONFIG.asteroid.reactionTimeStartSec,
      GAMEPLAY_CONFIG.asteroid.reactionTimeEndSec,
      difficulty,
    ),
  };
};
